import _ from 'lodash'
import { useState, useEffect } from 'react'
import { watchPartners } from '../fire'
import Table from './Table'
import Modal from './Modal'
import PartnerEditor from './PartnerEditor'

let Partners = ({ clients }) => {
  let [partners, setPartners] = useState([])
  useEffect(() => {
    let partnersOff = watchPartners(p => setPartners(p))

    return () => {
      partnersOff()
    }
  }, [])

  let clientIdOptions = _.map(clients, 'id')

  return (
    <div>
      <div className="my-2">
        <Modal
          maxWidth="90%"
          title="New Partner"
          trigger={openModal => (
            <button className="btn btn-sm btn-secondary" onClick={openModal}>
              <i className="fa fa-plus" /> New Partner
            </button>
          )}
          body={closeModal => (
            <PartnerEditor
              onClose={closeModal}
              clientIdOptions={clientIdOptions}
            />
          )}
        />
      </div>
      <Table
        data={partners}
        emptyText="No partners have been added yet."
        className="table-sm table-striped table-bordered small"
        columns={[
          { header: 'ID', key: 'id' },
          { header: 'Name', key: 'name' },
          {
            header: 'Clients',
            key: 'clientIds',
            render: ({ clientIds }) => _.keys(clientIds).length,
          },
          {
            header: 'Options',
            key: 'options',
            showSort: false,
            render: partner => (
              <Modal
                maxWidth="90%"
                title="Edit Partner"
                trigger={openModal => (
                  <button
                    className="btn btn-sm btn-secondary py-0"
                    onClick={openModal}
                  >
                    <i className="fa fa-edit" /> Edit
                  </button>
                )}
                body={closeModal => (
                  <PartnerEditor
                    partner={partner}
                    clientIdOptions={clientIdOptions}
                    onClose={closeModal}
                  />
                )}
              />
            ),
          },
        ]}
      />
    </div>
  )
}

export default Partners
